import React from 'react'
import T from 'prop-types'
import cx from 'classnames'
import Timing from '../hoc/Timing'

const HIDING_ANIM_DUR = 500

/**
PW Tab Content Pane

Single "sliding pane", meant to be a child of PW TabContent

Options (props)
- key [string, required]: 'key' of this element. Will be matched against parent "activeTabKey" prop

example configuration:
  <ReactBase.TabContent>
    <ReactBase.TabContentPane key="foo">
      Content
    </ReactBase.TabContentPane>
  </ReactBase.TabContent>

**/
class TabContentPane extends React.Component {
  static displayName = 'TabContentPane'

  static propTypes = {
    hidden: T.oneOf([false, 'left', 'right']),
    className: T.string,
    setTimer: T.func
  }

  state = {
    hiding: false
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.hidden && !this.props.hidden) {
      this.setState({hiding: true}, () => {
        this.props.setTimer(() => {
          this.setState({hiding: false})
        }, HIDING_ANIM_DUR, 'hiding')
      })
    }
  }

  render() {
    const {props, state} = this
    return (
      <div
        aria-hidden={!!props.hidden}
        className={cx(
          'tab_content_pane',
          props.hidden ? 'hidden_' + props.hidden : 'active_pane',
          state.hiding && 'hiding',
          props.className
        )}
      >
        {props.hidden && !state.hiding ? null : props.children}
      </div>
    )
  }
}

export default Timing(TabContentPane)
